export const FEATURE_FLAG_PROJECT_BRIDGE = "project-bridge"
export const PROJECT_BRIDGE_ACCESS_DEMAND = "$authoring:access-project-bridge"
